var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tourListHeader_headerArea', _vm.content ? '' : '-hidden']},[(_vm.content)?_c('h1',{staticClass:"tourListHeader_header"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }